import { ReactNode } from "react";

interface ButtonProps {
  children: ReactNode; // Button text or content
  size?: "sm" | "md"; // Button size
  variant?: "primary" | "outline"; // Button variant
  startIcon?: ReactNode; // Icon before the text
  endIcon?: ReactNode; // Icon after the text
  onClick?: () => void; // Click handler
  disabled?: boolean; // Disabled state
  className?: string; // Additional classes
  type?: "button" | "submit" | "reset"; // Button type for forms
}

const Button: React.FC<ButtonProps> = ({
  children,
  size = "md",
  variant = "primary",
  startIcon,
  endIcon,
  onClick,
  className = "",
  disabled = false,
  type = "button",
}) => {
  // Size Classes
  const sizeClasses = {
    sm: "px-[9px] py-1 text-[11.5px]",
    md: "px-4 py-[7px] text-[12px]",
  };

  // Variant Classes
  const variantClasses = {
    primary:
      "bg-neo-btngrad text-[var(--onaccent)] font-bold tracking-[-0.005em] shadow-[var(--btnglow)] hover:brightness-95",

    outline:
      "bg-[var(--ghostbg)] text-[var(--accent2)] font-semibold border border-[var(--ghostbd)] hover:bg-[var(--indigotint)]",
  };

  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 rounded-full transition ${className} ${
        sizeClasses[size]
      } ${variantClasses[variant]} ${
        disabled ? "cursor-not-allowed opacity-55" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {startIcon && <span className="flex items-center">{startIcon}</span>}
      {children}
      {endIcon && <span className="flex items-center">{endIcon}</span>}
    </button>
  );
};

export default Button;
